import { ExtraBase, QuoteApiModel, SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import { ProtectionExtraIds } from '../../ExtrasHelper';
import { ExtrasSelection } from '../ExtrasSelection';
import SidePanelSection, { SidePanelSections } from '../../../../../components/sidepanel-section';
import { ProtectionSelection } from '../ProtectionSelection';
import { TranslationNamespaces } from '~/lib/constants';
import { useTranslation } from 'react-i18next';
import { AppCard } from '~/components/card/app-card';
import { P2GBox } from '@parcel2go/core-ui';

interface props {
  onUpdate?: (extras: ExtraBase[]) => void;
  item: SmartSendItemApiModel;
  getQuote: () => Promise<QuoteApiModel>;
  currentSelection: ExtraBase[];
  showNonFoundMessage?: boolean;
  protectionEnabled: boolean;
  currentCoverPercentage: number;
}

export const ItemExtrasPanel: React.FC<props> = (props) => {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);

  return (
    <SidePanelSections>
      {props.protectionEnabled && (
        <SidePanelSection title={t('PARCEL_PROTECTION_SUBTITLE', { defaultValue: 'Parcel Protection' })}>
          <AppCard>
            <P2GBox p={3}>
              <ProtectionSelection
                includeServiceModel={true}
                currentCoverPercentage={props.currentCoverPercentage}
                getQuote={props.getQuote}
                item={props.item}
                currentSelection={props.currentSelection}
                onUpdate={(q, o) => {
                  const _extras = props.currentSelection.filter((x) => !ProtectionExtraIds.includes(x.Id));
                  o?.Extras.forEach((e) => {
                    if (!_extras.find((x) => x.Id === e.Id)) {
                      _extras.push(e);
                    }
                  });
                  props.onUpdate(_extras);
                }}
              />
            </P2GBox>
          </AppCard>
        </SidePanelSection>
      )}
      <SidePanelSection title={t('ADDITIONAL_SUBTITLE', { defaultValue: 'Additional' })}>
        <ExtrasSelection
          item={props.item}
          showNonFoundMessage={props.showNonFoundMessage}
          getQuote={props.getQuote}
          currentSelection={props.currentSelection}
          onUpdate={(o) => {
            const _extras = props.currentSelection.filter((x) => ProtectionExtraIds.includes(x.Id));
            o?.forEach((e) => {
              if (!_extras.find((x) => x.Id === e.Id)) {
                _extras.push(e);
              }
            });
            props.onUpdate(_extras);
          }}
        />
      </SidePanelSection>
    </SidePanelSections>
  );
};
